import { render, staticRenderFns } from "./FocusContainer.vue?vue&type=template&id=b1b33814&scoped=true&"
import script from "./FocusContainer.vue?vue&type=script&lang=js&"
export * from "./FocusContainer.vue?vue&type=script&lang=js&"
import style0 from "./FocusContainer.vue?vue&type=style&index=0&id=b1b33814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b33814",
  null
  
)

export default component.exports